import React from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { Link } from 'react-router-dom'
import CLogLike from "../like/index";
import { IMAGE_GEEKO_LTD } from '../../../../../constants'
import withClogScroll from '../../../../hocs/clog-scoll'

export default withClogScroll(props => {
    useStyles(classes)
    const { showing, sensors, innerRef } = props
    const { mainImageHeight, mainImageWidth, mainImage, description, customerName, numberOfLike, liked, customerId, type, id, youtubeId } = showing
    const aspectRatio = mainImageWidth && mainImageHeight ? `${mainImageWidth} / ${mainImageHeight}` : undefined
    const url = type !== 2 ? `/v-shop/im/${id}?tab=${sensors?.tab}`: `/v-shop/vi/${id}?tab=${sensors?.tab}`


    return <div className={classes.Showing}>
        <Link 
            style={{ aspectRatio }} 
            className={classes.Image} 
            to={url}
            ref={innerRef}
            data-type={type === 2 ? '视频' : '图片'}
            data-id={type === 2 ? youtubeId : mainImage}
            data-position={sensors?.position}
            data-tab={sensors?.tab}
        >
            <LazyLoadImage
                alt={description}
                src={mainImage}
            />

            {
                type === 2 && <span className={classes.PlayIcon}></span>
            }
        </Link>
        <div className={classes.Name}>{description}</div>
        <div className={classes.Tools}>
            <span className={classes.Customer}>
                <span className={classes.Avatar} style={{background:`url(${!!customerId?`https://s3-us-west-2.amazonaws.com/image.chic-fusion.com/icon/${customerId}`:`${IMAGE_GEEKO_LTD}/chicme/20220801/clog_default_icon.svg`}) center/cover no-repeat;`}}></span>
                <span className={classes.Nick}>{customerName}</span>
            </span>

            <CLogLike liked={liked} showing={showing} numberOfLike={numberOfLike} />
        </div>
    </div>
})